export default __webpack_public_path__ + "static/skato-cd6d9deddbfcc5dd5936b129ef703529.png";